import React from 'react'
import { Tool } from '../../models/Tool'
import RightArrow from '../../assets/right-green-arrow.svg'
import { useNavigate } from 'react-router-dom'

type Props = Tool

const ToolCard = ({ features, title, subTitle }: Props) => {
    const navigate = useNavigate()
    return (
        <div className='py-[2vh] px-[1.2vw] bg-white border-black border-opacity-20 rounded-[5px] border border-solid border-[#0003] shadow-module-card'>
            <h3 className='text-[#000] leading-[1vw] home-page-footer-title text-left font-bold'>{title.map((value) => <>{value}<br /></>)}</h3>
            <p className="text-[#000] home-page-footer-subtitle italic text-left py-1.5 mb-2 mt-2">{subTitle}</p>
            {
                features.map(({ id, name, url }, index) => (
                    <div onClick={() => { if (url) navigate(url) }} key={id} className={`px-[10px] py-1 border-t border-[#CDCDCD] flex justify-between ${index == features.length - 1 ? 'border-b' : ''} ${url ? "cursor-pointer" : "cursor-not-allowed"}`}>
                        <h4 className='home-page-footer-subtitle leading-[20.43px] font-normal  '>{name}</h4>
                        <img src={RightArrow} />
                    </div>
                ))
            }
        </div>
    )
}

export default ToolCard